import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { School } from '../school';
import { SchoolMemo } from '../school-memo';
import { Router } from '@angular/router';
import { CKEDITORCONFIG } from '../ckeditor-config';
import { SelectItemGroup } from 'primeng/api';
import { Region } from '../region';
import { ProgrammeType } from '../programme-type';
import { Language } from '../language';
import { Country } from '../country';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-school-create',
  templateUrl: './school-create.component.html',
  styleUrls: ['./school-create.component.css']
})
export class SchoolCreateComponent implements OnInit {

  schoolForm!: FormGroup;
  nameIsNull = false;
  countries: Country[] = [];
  regions: Region[] = [];
  itemGroups: SelectItemGroup[] = [];
  programmeTypes: ProgrammeType[] = [];

  public Editor = Editor;

  // error if I try to iterate in array in schoolForm directly
  get formData(){return <FormArray>this.schoolForm.get("countries");}
  get programmeTypeFormData(){return <FormArray>this.schoolForm.get("programmeTypes");}

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private router: Router
  ) { }

  ngOnInit() {
    this.schoolForm = this.builder.group({
      name: "",
      comment: "",
      hasOnlineCourse: [false, Validators.required],
      onlineCourseDescription: null,
      countries: new FormArray([new FormControl(null)]),
      programmeTypes: new FormArray([new FormControl(null)]),
      externalName: [null, Validators.required]
    });
    this.httpService.getAllCountries().subscribe(res => this.countries = res);
    this.httpService.getAllProgrammeTypes().subscribe(res => this.programmeTypes = res);
    this.httpService.getRegions().subscribe(res =>{
      this.regions = res;
      for(let region of this.regions){
        this.itemGroups.push({
          label: region.name,
          items: this.setItems(region)
        });
      }
    });
  }

  setItems(region: Region){
    let items = [];
    for(let country of region.countries){
      items.push({
        label: country.name,
        value: country
      });
    }
    return items;
  }

  editorConfig: any = CKEDITORCONFIG;

  sendForm(){
    this.nameIsNull = false;
    if(this.schoolForm.value.name == ""){
      console.log("name is empty");
      this.nameIsNull = true;
      return;
    }
    let onlineCourseDescription = this.schoolForm.value.onlineCourseDescription;
    if(!this.schoolForm.value.hasOnlineCourse){
      onlineCourseDescription = null;
    }
        // remove zero width space in the comment
        let comment = this.schoolForm.value.comment.replace(/\u200B/g,"");

    this.httpService.postSchool(
      new School(
        this.schoolForm.value.name,
        new SchoolMemo(comment),
        false,
        this.setCountries(),
        [],
        this.setProgrammeTypes(),
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        new Language(2, "English"),
        [],
        this.schoolForm.value.externalName
      )
    ).subscribe(() => {
      console.log("success");
      this.router.navigateByUrl("/management/schools");
    });
  }
  setCountries(){
    let countryList = [];
    let countries = this.schoolForm.get("countries") as FormArray;
    for(let country of countries.controls){
      if(country.value){
        countryList.push(
          country.value
        );
      }
    }
    return countryList;
  }

  setProgrammeTypes(){
    let programmeTypeList = [];
    let programmeTypes = this.schoolForm.get("programmeTypes") as FormArray;
    for(let programmeType of programmeTypes.controls){
      if(programmeType.value){
        programmeTypeList.push(
          programmeType.value
        );
      }
    }
    return programmeTypeList;
  }

  addCountry(){
    let countries = this.schoolForm.get("countries") as FormArray;
    countries.push(new FormControl(null));
  }

  addProgrammeType(){
    let programmeTypes = this.schoolForm.get("programmeTypes") as FormArray;
    programmeTypes.push(new FormControl(null));
  }
  testForm(){
    console.log(this.schoolForm);
    
  }
}
